/* @flow */
/**
 * Internal dependencies
 */
import { api } from 'shared/config';

export const getModule = () : number => {
	if ( window.brukHueConfig && window.brukHueConfig.module ) {
		return window.brukHueConfig.module;
	}

	return 2;
};

/**
 * Get url from redux state
 */
export const getUrlFromState = ( state: Object ) : { key: string, url: string } => {
	let url, key;

	if ( state.user.track ) {
		key = 'track';
		url = `${ api }get/track?id=${ state.user.track }`;
	} else {
		key = 'init';
		url = `${ api }init?module=${ getModule() }`;
	}

	return {
		url,
		key,
	};
};



// WEBPACK FOOTER //
// ./shared/api.js